const strings = {
  labels: {
    heading: 'Log Outcome',
    taskNotes: 'Task Notes',
    callOutcome: 'Call Outcome',
    submitButton: 'Log Outcome',
    submitDisabledTooltip:
      'The call must end and outcome must be selected to log the outcome and complete the task.',
  },
  placeholders: {
    taskNotes: 'Enter task notes...',
    callOutcome: 'Select outcome',
  },
} as const;

export default strings;
